// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

//tabs

$('#tabs-all').on('click',function(){
	event.preventDefault();
	$('.tabs__content').slideDown().addClass('active');
});


$('.tabs__title a').on('click',function(){
	event.preventDefault();
	var hash = $(this).prop("hash");
	var nohash = hash.slice(1);
	$(this).parent('li').toggleClass('active');
	$(this).parent('li').siblings().removeClass('active');
	$('.tabs__content').not('#'+ nohash).slideUp().removeClass('active');
	$('#'+ nohash).slideDown().addClass('active');
});

//accordions
$('.accordions__heading').on('click',function(){

	if ($(this).hasClass("active")) {
		$(this).removeClass('active');
	} else{
		$(this).addClass('active');
	}
	$(this).parents().siblings().children('.accordions__heading').removeClass('active');
	$(this).parents().siblings().children('.accordions__content').slideUp(100);
	$(this).siblings('.accordions__content').slideToggle(100);

});

//insurances
$('.crops__single__long__show').on('click',function(){
	$(this).toggleClass('active');
	$(this).siblings('.crops__single__long').slideToggle();
});




$('#job__apply').on('click',function(){
	$(this).parent('.job__section__apply').hide();
	$('#job__form').slideDown();
	var titleSingle = $('h1').text();
	$('.single-career #form-job-title').attr('value',titleSingle);
});


$('.dropdown-toggle').on('click', function(){


	var clicked = $(this);

	setTimeout(function() {
		
		$(clicked).siblings('.dropdown-menu').toggleClass('active');

	}, 100);

	
});



$(document).click(function(event) {
    if ( !$(event.target).hasClass('dropdown-toggle')) {
         $('.dropdown-menu').removeClass('active');
    }
});




$('input[type="file"]').on('change',function(){
	$('input[type="file"]').addClass('hidden');
	$("#uploaded__delete").addClass('active');
	var filename = $(this).val().replace(/.*(\/|\\)/, '');
	$('#uploaded__file').html(filename);
});

$('#uploaded__delete').on('click', function(){
	event.preventDefault();
	$(this).removeClass('hidden');
	$("#uploaded__delete").removeClass('active');
	$('input[type="file"]').removeClass('hidden');
	$('#uploaded__file').html('');
	$('input[type="file"]').val(null); 
});



$('#search__show,#search__show__mobile').on('click', function(){
	event.preventDefault();
	$("#search__fixed").toggleClass('active');
});


$('#search__close').on('click', function(){
	event.preventDefault();
	$("#search__fixed").removeClass('active');
});


$('#lang__show').on('click', function(){
	event.preventDefault();
	$("#lang__menu").toggleClass('active');
	$(this).toggleClass('active');
	$(this).parent().toggleClass('active');
	



});




$(document).on("scroll", function () {

	$("#lang__menu,#lang__show,#lang__outer").removeClass("active");
	$('.dropdown-menu').removeClass('active');
	setTimeout(function() {
		
		$('.dropdown-menu,.dropdown-toggle').removeClass('show');
		$('.dropdown-toggle').prop('aria-expanded',false);
	}, 301);

});



$("#page-header .navbar-toggler").on('click', function () {
	if ($(this).hasClass("active")) {
		$("#navbar,#frame__menu").removeClass("slide");
		$('body').removeClass('unscroll');
		setTimeout(function() {
			
			$('#navbar,#frame__menu').removeClass('active');

		}, 301);

	  $(this).removeClass("active");
	}
	else {
	  $(this).addClass("active");
	  $('#navbar, #frame__menu').addClass('active');
	  $('body').addClass('unscroll');
		setTimeout(function() {
			
			$('#navbar,#frame__menu').addClass('slide');

		}, 301);
	}
  });


$('.menu__footer__title').on('click',function(){
	$(this).siblings().toggleClass('active');
	$(this).toggleClass('active');
});

//circle
$('.risks__circle__item__btn').on('click',function(){
	$(this).addClass('active');
	$(this).parent().siblings().children().removeClass('active');
	var activeContent = $(this).attr('content-active');
	$('#' + activeContent).siblings().hide();
		
		setTimeout(function(){
			$('#' + activeContent).fadeIn();
		}, 201);
});

// $('.risks__circle__item button').on('click',function(){
// 	$(this).parent().addClass('active');
// 	$(this).parent().siblings().removeClass('active');
// 	var activeCircle = $(this).attr('circle-active');
// 	$(this).parent().parent().attr('circle-active',activeCircle);
// 	var activeContent = $(this).attr('content-active');
// 	$('#' + activeContent).siblings().hide();
// 		setTimeout(function(){
// 			$('#' + activeContent).fadeIn();
// 	}, 201);
// });


//popups 
setTimeout(function(){
	$('#vh-popup').addClass('active');
}, 3000);



$('#vh-popup__hide').on('click',function(){
	localStorage.setItem('hiddenPopup', 'true');
	$('#vh-popup').removeClass('active');
	$('#vh-popup__show').addClass('active');
});

$('#vh-popup__bottom__hide').on('click',function(){
	$('#vh-popup__bottom').removeClass('active');
});


$('#vh-popup__bottom__hide').on('click',function(){
	$('#vh-popup__bottom').removeClass('active');
});



$('#vh-popup__show').on('click',function(){
	$(this).removeClass('active');
	
		$('#vh-popup').addClass('active');

});


//On the same page or other page

if (localStorage.getItem('hiddenPopup')){


	


setTimeout(function(){
	//$('#vh-popup').removeClass('active');
	$('#vh-popup__show').removeClass('active');
}, 3001);

}


$(".post__index a[href^='#']").click(function(){
    var url = $(this).attr('href');
    $('html,body').animate({scrollTop: $(url).offset().top - 120}, 500);
  });
